import React, {useEffect, useRef, useState} from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import roleService from "../service/RoleService";
import {useTranslation} from "react-i18next";
import {Controller} from "react-hook-form";
import RenderTags from "./RenderTags";


const RoleInput = ({name, label, defaultValue, rules, error, multiple = true, disabled, control, limitTags = 2}) => {

    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const {t} = useTranslation();

    const searchTimeout = useRef(null);

    useEffect(() => {
        let active = true;
        setLoading(true);
        if (!inputValue) {
            setOptions([]);
            setLoading(false);
        } else {
            if (searchTimeout.current) {
                clearTimeout(searchTimeout.current);
            }
            searchTimeout.current = setTimeout(async () => {
                try {
                    setLoading(true);
                    const {data} = await roleService.search({
                        start: 0,
                        data: {name: inputValue},
                        max: 50
                    });
                    const result = data.map(item => ({...item}));
                    if (active) {
                        setOptions(result || []);
                        setLoading(false);
                    }
                } catch (e) {

                }
            }, 500);
        }
        return () => {
            active = false;
        };
    }, [inputValue]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };


    return (
        <Controller
            render={({field}) => (
                <Autocomplete
                    {...field}
                    multiple={multiple}
                    getOptionLabel={(role) => role.name || ""}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    options={options}
                    filterOptions={(x) => x}
                    loading={loading}
                    limitTags={limitTags}
                    disabled={disabled}
                    renderTags={RenderTags}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label || (multiple ? t('label.roles') : t('label.role'))}
                            error={error && true}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                            helperText={error?.message}
                            onChange={handleChange}
                        />
                    )}
                    onChange={(_, data) => field.onChange(data)}
                />
            )}
            name={name}
            control={control}
            defaultValue={defaultValue ? defaultValue : (multiple ? [] : "")}
            rules={rules}
        />
    );
};

export default RoleInput;
